import React from 'react'
import MaterialSymbol from '../material-symbol'

const InsertChart = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="insert_chart" {...props} />
))

InsertChart.displayName = 'InsertChart'

export default InsertChart
